(function () {
    'use strict';

    angular
        .module('core.services')
        .service('EmailTypeService', EmailTypeService)

    /** @ngInject */
    function EmailTypeService(HttpService) {
        const EmailTypeService = {
            getAll
        }

        return EmailTypeService;

        function getAll() {
            return HttpService.get('/people/emails/types');
        }
    }
}());